import React, { useEffect, useState } from 'react'

import { 
  Outlet,
  useNavigate,
  useParams
} from 'react-router-dom'

import useFirebase from 'hooks/firebase'

import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'

import PersonalInformation from 'widgets/personal'
import AssignedStudentsTable from 'widgets/students/table'

const PreceptorDetails = (props) => {
  const { director } = props

  const params = useParams()
  const id = params.id

  const navigate = useNavigate()

  const { firestore, functions } = useFirebase()
  const {
    addPreceptorToStudent,
    getPreceptor,
    getStudentsBySchoolId,
    preceptor,
    removePreceptorFromStudent,
    students
  } = firestore
  const { deleteProfile } = functions

  const [showUnassigned, setShowUnassigned] = useState(false)
  const handleShowUnassigned = (event) => {
    setShowUnassigned(event.target.checked)
  }

  useEffect(() => {
    getPreceptor(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (director === undefined) return
    getStudentsBySchoolId(director.schoolId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [director])

  const [assignedStudents, setAssignedStudents] = useState([])
  const [unassignedStudents, setUnassignedStudents] = useState([])

  const refreshStudents = () => {
    var assignedData = []
    var unassignedData = []
    students.forEach((student) => {
      const formatted = {
        'id': student['id'],
        'name': student['name'],
        'email': student['email'],
        'stage': student['level'],
        'preceptor':  student['preceptor'] !== undefined ? student['preceptor']['name'] : 'Sin asignar',
      }

      const preceptor = student['preceptor']
      if (preceptor === undefined) {
        unassignedData.push(formatted)
      } else if (preceptor['id'] === id) {
        assignedData.push(formatted)
      } else {
        return
      }
    })
    setAssignedStudents(assignedData)
    setUnassignedStudents(unassignedData)
    setRows(assignedData)
  }

  useEffect(() => {
    if (students === undefined) return
    refreshStudents()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [students])

  useEffect(() => {
    if (showUnassigned) {
      setRows(unassignedStudents)
    } else {
      setRows(assignedStudents)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showUnassigned])

  const [deleting, setDeleting] = useState(false)
  const onDelete = async () => {
    setDeleting(true)
    await deleteProfile({
      'uid': id,
      'role': 'preceptor'
    })
    setDeleting(false)
    navigate('/director/preceptores')
  }

  const [rows, setRows] = useState([])

  const [selectedStudents, setSelectedStudents] = useState([])
  const [assigning, setAssigning] = useState(false)

  const handleAssignment = () => {
    setAssigning(true)
    if (showUnassigned) {
      const p = {
        'id': preceptor.id,
        'email': preceptor.email,
        'name': preceptor.name
      }
      selectedStudents.forEach(async studentId => {
        await addPreceptorToStudent(studentId, p)
      })

      setShowUnassigned(false)
    } else {
      selectedStudents.forEach(async studentId => {
        await removePreceptorFromStudent(studentId)
      })
    }
    setAssigning(false)
  }
  
  if (preceptor === undefined) return <Outlet />
  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Button onClick={() => navigate(-1)} size='large' startIcon={<ArrowBackIcon />}>
          <b>Volver</b>
        </Button>
      </Grid>
      <Grid item xs={12} md={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PersonalInformation collection='preceptors' profile={preceptor} deleting={deleting} onDelete={onDelete} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              {/* <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>LISTA DE ALUMNOS</b>
                </Typography>
              </Grid> */}
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography color='primary' variant='body1'>
                      <b style={{ fontWeight: 900 }}>LISTA DE ALUMNOS</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={6} align='right'>
                    <FormControlLabel control={<Checkbox checked={showUnassigned} onChange={handleShowUnassigned} size='small' />} label={<Typography variant='body2'>Mostrar alumnos sin preceptor</Typography>} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <AssignedStudentsTable onStudentsSelected={setSelectedStudents} rows={rows} />
              </Grid>
              <Grid item xs={12}>
                <LoadingButton disabled={selectedStudents.length === 0} disableElevation loading={assigning} loadingPosition='start' startIcon={showUnassigned ? <PersonAddAlt1Icon /> : <PersonRemoveIcon />} variant='contained' onClick={handleAssignment}>
                  <b style={{ fontWeight: 900 }}>{showUnassigned ? 'ASIGNAR' : 'DESASIGNAR'}</b>
                </LoadingButton>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      {/* <Grid item xs={3}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>ALUMNOS SIN PRECEPTOR</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid> */}
    </Grid>
  )
}

export default PreceptorDetails